import { Modal } from "antd";
import Axios from "axios";
import { API_ADDRESS } from "..";
import { GetToken } from "../helper";

export async function GetQuoteRequests(isCompleted) {
  const response = await Axios.get(
    `${API_ADDRESS}/api/quote-requests/${isCompleted}`,
    {
      headers: {
        Authorization: "Bearer " + GetToken(),
      },
    }
  )
    .then((res) => {
      // Backend'den gelen targets string'ini parse et
      const data = res.data;
      let processedData = [];

      if (Array.isArray(data)) {
        processedData = data;
      } else if (
        data &&
        typeof data === "object" &&
        data.data &&
        Array.isArray(data.data)
      ) {
        // Eğer response { data: [...] } formatında ise
        processedData = data.data;
      } else {
        return [];
      }

      return processedData.map((item) => {
        const parsedTargets =
          typeof item.targets === "string"
            ? JSON.parse(item.targets)
            : item.targets;
        if (item.manufacturerQuotes && Array.isArray(item.manufacturerQuotes)) {
          item.manufacturerQuotes = item.manufacturerQuotes.reduce(
            (acc, quote) => {
              const index = acc.findIndex(
                (q) => q.createdBy === quote.createdBy && quote.id > q.id
              );

              if (index !== -1) {
                acc.splice(index, 1);
              }

              acc.push(quote);
              return acc;
            },
            []
          );
        }

        return {
          ...item,
          targets: parsedTargets,
        };
      });
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Teklif talepleri yüklenirken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return [];
    });

  return response;
}

export async function GetQuoteRequestsByRole() {
  const response = await Axios.get(`${API_ADDRESS}/api/quote-requests/role`, {
    headers: {
      Authorization: "Bearer " + GetToken(),
    },
  })
    .then((res) => {
      // Backend'den gelen targets string'ini parse et
      const data = res.data;
      let processedData = [];

      if (Array.isArray(data)) {
        processedData = data;
      } else if (
        data &&
        typeof data === "object" &&
        data.data &&
        Array.isArray(data.data)
      ) {
        // Eğer response { data: [...] } formatında ise
        processedData = data.data;
      } else {
        return [];
      }

      // Her quote request için targets'ı parse et ve kullanıcının teklifini bul
      const currentUserId =
        JSON.parse(sessionStorage.getItem("user") || "{}").id || "";

      return processedData.map((item) => {
        const parsedTargets =
          typeof item.targets === "string"
            ? JSON.parse(item.targets)
            : item.targets;

        // Kullanıcının verdiği en son teklifi bul
        let userQuote = null;
        if (item.manufacturerQuotes && Array.isArray(item.manufacturerQuotes)) {
          if (item.manufacturerQuotes.length > 0) {
            // En son teklifi al (en yüksek ID'li)
            userQuote = item.manufacturerQuotes.reduce((latest, current) =>
              current.id > latest.id ? current : latest
            );
          }
        }

        return {
          ...item,
          targets: parsedTargets,
          userQuote: userQuote, // Kullanıcının verdiği teklif
          hasUserQuote: !!userQuote, // Kullanıcının teklif verip vermediği
        };
      });
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Teklif talepleri yüklenirken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return [];
    });

  return response;
}

export async function CreateQuoteRequest(quoteRequest) {
  const response = await Axios.post(
    `${API_ADDRESS}/api/quote-requests`,
    {
      targets: quoteRequest.targets,
      productName: quoteRequest.productName,
      description: quoteRequest.description,
      quantity: quoteRequest.quantity,
      unit: quoteRequest.unit,
      status: quoteRequest.status,
      createdBy: quoteRequest.createdBy,
      genericTaskId: quoteRequest.genericTaskId,
    },
    {
      headers: {
        Authorization: "Bearer " + GetToken(),
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        Modal.success({
          title: "Başarılı",
          content: <p>Teklif talebi başarıyla oluşturuldu.</p>,
          okText: "Tamam",
        });
      }
      return true;
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Teklif talebi oluşturulurken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return false;
    });

  return response;
}

export async function DeleteQuoteRequest(id) {
  const response = await Axios.delete(
    `${API_ADDRESS}/api/quote-requests/${id}`,
    {
      headers: {
        Authorization: "Bearer " + GetToken(),
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        Modal.success({
          title: "Başarılı",
          content: <p>Teklif talebi başarıyla silindi.</p>,
          okText: "Tamam",
        });
      }
      return true;
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Teklif talebi silinirken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return false;
    });

  return response;
}

export async function CreateManufacturerQuote(manufacturerQuote) {
  const response = await Axios.post(
    `${API_ADDRESS}/api/quote-requests/manufacturer-quotes`,
    manufacturerQuote,
    {
      headers: {
        Authorization: "Bearer " + GetToken(),
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        Modal.success({
          title: "Başarılı",
          content: <p>Üretici teklifi başarıyla oluşturuldu.</p>,
          okText: "Tamam",
        });
      }
      return true;
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Üretici teklifi oluşturulurken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return false;
    });

  return response;
}

export async function UpdateManufacturerQuote(id, manufacturerQuote) {
  const response = await Axios.put(
    `${API_ADDRESS}/api/quote-requests/manufacturer-quotes/${id}`,
    manufacturerQuote,
    {
      headers: {
        Authorization: "Bearer " + GetToken(),
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        Modal.success({
          title: "Başarılı",
          content: <p>Üretici teklifi başarıyla güncellendi.</p>,
          okText: "Tamam",
        });
      }
      return true;
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Üretici teklifi güncellenirken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return false;
    });

  return response;
}

export async function DeleteManufacturerQuote(id) {
  const response = await Axios.delete(
    `${API_ADDRESS}/api/quote-requests/manufacturer-quotes/${id}`,
    {
      headers: {
        Authorization: "Bearer " + GetToken(),
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        Modal.success({
          title: "Başarılı",
          content: <p>Üretici teklifi başarıyla silindi.</p>,
          okText: "Tamam",
        });
      }
      return true;
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Üretici teklifi silinirken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return false;
    });

  return response;
}

export async function UpdateQuoteRequestStatus(id, quoteId, status) {
  const response = await Axios.get(
    `${API_ADDRESS}/api/quote-requests/${id}/${status}/${quoteId}`,
    {
      headers: {
        Authorization: "Bearer " + GetToken(),
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        Modal.success({
          title: "Başarılı",
          content: <p>Teklif talebi durumu başarıyla güncellendi.</p>,
          okText: "Tamam",
        });
      }
      return true;
    })
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: <p>Teklif talebi durumu güncellenirken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return false;
    });

  return response;
}
